export default __webpack_public_path__ + "static/media/work8.d3b6fa58.png";